import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new"
import FieldDropdown_PopoverOptionUser from "../../components/option/option-user"
import {FieldAutomationActionFormProps} from "../../../../render/automation-action-form";
import FieldUser_DropdownValueNotEmpty from "../../components/dropdown/value-not-empty";

export default class FieldUser_AutomationActionForm extends React.Component<FieldAutomationActionFormProps> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    onChangeToValue     = (option:any)  => this.props.onChangeCallback({toValue: option.value})

    render() {

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        return (
            <div className="flex-row-left-top">
                <div className={labelClasses}>to</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {this.props.field.getAutomationOptions()}
                                  value                         = {this.props.config.toValue}
                                  popoverContainerClasses       = "max-w-200"
                                  popoverScrollContainerClasses = "max-h-200"
                                  valueComponent                = {FieldUser_DropdownValueNotEmpty}
                                  popoverOptionComponent        = {FieldDropdown_PopoverOptionUser}
                                  isSearchable                  = {true}
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }
}